import { toLower } from 'lodash';
import { MetricDomain } from '@mode/shared/contract-common';
import { getEmbeddedCollection } from '@mode/shared/util-halogen';
import { MetricDimensionResource } from '../metric-dimensions/metric-dimension-response.types';
import { MetricResource } from '../metrics/metric-response.types';

export function toMetric(resource: MetricResource): MetricDomain.Metric {
  return {
    id: resource.id,
    token: resource.token,
    dataSourceId: resource.data_source_id,
    dataSourceName: resource.data_source_name,
    name: resource.name,
    desc: resource.desc,
    label: resource.label,
    type: resource.calc_type,
    sql: resource.sql,
    timestamp: resource.timestamp,
    timeGrains: (resource.time_grains ?? []).map(toLower),
    dimensions: resource.dimensions,
    attrs: tmpGetMetricDimensions(resource),
  };
}

/**
 * @note Returns an array of metric attrs ensuring that an attr for the metric and timestamp are included
 */
function tmpGetMetricDimensions(resource: MetricResource): MetricDomain.Dimension[] {
  const dimensions: MetricDomain.Dimension[] = [];

  // Attrs sans metric
  const attrs = (getEmbeddedCollection<MetricDimensionResource>(resource, 'metric_attrs') || []).filter(
    (attr) => toLower(attr.name) !== toLower(resource.name)
  );

  // Metric
  dimensions.push({
    name: toLower(resource.name),
    desc: resource.desc,
    type: MetricDomain.AttrType.Metric,
    dataType: 'float',
  });

  // Timestamp
  const tsAttr = attrs.find((a) => toLower(a.name) === toLower(resource.timestamp));
  dimensions.push({
    name: toLower(tsAttr?.name ?? resource.timestamp),
    desc: tsAttr?.description ?? 'Metric timestamp',
    type: MetricDomain.AttrType.Timestamp,
    dataType: 'date',
  });

  // Dimensions
  // - Need to re-key `type` -> `dataType`
  // - Add `type: Timestamp | Dimension`
  for (const attr of attrs) {
    if (toLower(attr.name) !== toLower(resource.timestamp)) {
      dimensions.push({
        name: toLower(attr.name),
        desc: attr.description,
        type: MetricDomain.AttrType.Dimension,
        dataType: attr.data_type ?? attr.type,
      });
    }
  }

  return dimensions;
}
